export const OLD_CLIENT_FOLLOWUP_ID = 10;


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/config/followup.ts